require('./DeviceClassCard.css');

export type Props = {
    imageSrc: string;
    displayName: string;
    isActive: boolean;
    onSelect(): void;
};

export const DeviceClassCard = ({ imageSrc, displayName, isActive, onSelect }: Props) => (
    <div className={ `device-class-card ${isActive ? 'active' : ''}` } onClick={ onSelect }>
        <img className="device-class-icon" src={ imageSrc }/>
        <p className="device-class-name">
            { displayName }
        </p>
    </div>
);
